import Attivita from './Attivita';
import {minutesToHuman} from '../Helpers'

class AttivitaDettagliata extends Attivita {

    createPdf(items){

        const columns = [
            {title: "Giorno", dataKey: "giorno"},
            {title: "Colore", dataKey: "colore"},
            {title: "Commessa", dataKey: "com"},
            {title: "Utente", dataKey: "ute"},
            //{title: "Num sessioni", dataKey: "ses"},
            //{title: "Durata Totale\n(minuti)", dataKey: "duratamin"},
            {title: "Durata Totale\n(h:m:s)", dataKey: "duratahms"},
            {title: "Note", dataKey: "note"},
        ];
        let rows = [];
        let durataPesataTot = 0;

        items.map((item) => {
            let it = {
                giorno: item.giorno,
                colore: item.commessa.colore,
                com: item.commessa.nomeCompleto + ' [' + item.commessa.idCommessa + ']',
                ute: item.utente.username,
                //ses: item.numAttivita,
                //duratamin: item.durataPesata,
                duratahms: minutesToHuman(item.durataPesata),
                note: item.nota
            };
            rows.push(it);
            durataPesataTot += item.durataPesata;
            return 0;
        });
        rows.push({
            id: '',
            colore: '',
            com: '',
            ute: '',
            duratahms: minutesToHuman(durataPesataTot),
            note: '',
        })


        super.createPdf(columns, rows,
            {
                createdCell: this.doDrawCell,
                drawRow: this.doDrawRow,
                columnStyles: {
                    com: {halign: 'left', columnWidth: 'auto'},
                    ute: {halign: 'left', columnWidth: 'auto'},
                    duratahms: {halign: 'center'},
                    note: {halign: 'left', columnWidth: 'auto'},
                },
                headerStyles: {
                    valign: 'middle',
                    halign: 'center',
                    //fillColor: [0x56, 0x9e, 0xdd],
                    //fillColor: [0xFF, 0xFF, 0xFF],
                    fillColor: false,
                    textColor: [0,0,0],
                    duratahms:{halign: 'center'},
                },
            });
    }


}

export default AttivitaDettagliata;


/** WEBPACK FOOTER **
 ** ./src/pdf/AttivitaDettagliata.js
 **/